// Parâmetros do modelo de viabilidade de preço — política comercial da loja.
// Não altere os números sem validar com a gerência.
export const PARAMS = {
  taxaPropriaAno: 0.20,          // juros a.a. — crediário próprio (carnê)
  taxaCartaoAno: 0.15,           // juros a.a. — cartão de crédito
  inadimplenciaPropria: 0.10,    // só o crediário próprio carrega inadimplência
  inadimplenciaCartao: 0.0,      // risco é do emissor do cartão, não da loja
  markupMoveis: 0.40,            // margem de lucro padrão à vista sobre o custo médio (móveis e demais)
  markupEletro: 0.30,            // margem de lucro padrão à vista sobre o custo médio (eletro)
  // À vista: o gerente pode liberar até 10 pontos de margem abaixo do padrão
  // (ex.: eletro custo × 1,20; móveis custo × 1,30). Abaixo disso é inviável.
  descMaxAvistaMoveis: 0.10,
  descMaxAvistaEletro: 0.10,
  // Cartão de crédito: o gerente pode liberar até 5% de desconto sobre o preço sugerido.
  // Crediário (carnê): sem desconto do gerente — abaixo do sugerido é inviável.
  descMaxGerenteCartao: 0.05,
  descMaxGerenteCrediario: 0,
  parcelasMax: 24,
};

// Formas de pagamento da condição de venda. O preço sugerido parcelado é o preço à vista
// padrão acrescido dos juros do "empréstimo" (e da inadimplência, no crediário).
export const FORMAS_PAGAMENTO = {
  avista: { label: 'À vista', taxaAno: 0, inadimplencia: 0 },
  cartao: {
    label: 'Cartão de crédito', taxaAno: PARAMS.taxaCartaoAno, inadimplencia: PARAMS.inadimplenciaCartao,
    descMaxGerente: PARAMS.descMaxGerenteCartao,
  },
  crediario: {
    label: 'Crediário (carnê)', taxaAno: PARAMS.taxaPropriaAno, inadimplencia: PARAMS.inadimplenciaPropria,
    descMaxGerente: PARAMS.descMaxGerenteCrediario,
  },
};

// Motivos aceitos para liberação de preço abaixo do padrão (gerente) ou inviável.
export const MOTIVOS_LIBERACAO = {
  avaria_estoque_antigo: 'Produto com avarias, defeito ou estoque antigo',
  outros: 'Outros',
};
